import React, { useEffect, useRef, useState } from "react";
import { Form, Select, } from "antd";
import Webcam from "react-webcam";
import FaceApiJsLoaded from "./FaceApiJsLoaded";
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import { getFullFaceDescription } from "../../faceUtil";
import { DEFAULT_WEBCAM_RESOLUTION, inputSize, webcamResolutionType } from "../../globalData";
import { drawRectAndLabelFace } from "../../utils/drawRectAndLabelFace";
import PersonPinCircleIcon from '@mui/icons-material/PersonPinCircle';
import { Row, Col } from "react-bootstrap";
import { _rest, Notification } from '../../services/api';
import { useHistory } from "react-router-dom";
import { ICONS } from "../../theme"
import { CONFIG } from "../../config";
import { Modal } from 'antd';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import INSTRUCTIONS from "./instructions";
import { IMGS } from "../../theme";
import useWindowDimensions from "../../hooks/useWindowDimensions";



const { Option } = Select;
let interval;

export default (props) => {
   const { participants, faceMatcher, facePhotos, user, GeoLocationData } = props;
   const [isFaceAPIModelsLoaded, setIsFaceAPIModelsLoaded] = useState(false);
   const [isWebcamEnabled, setIsWebcamEnabled] = useState(false);

   const [inputDevices, setInputDevices] = useState([]);
   const [selectedWebcam, setSelectedWebcam] = useState();
   const [fullDesc, setFullDesc] = useState(null);

   const [waitText, setWaitText] = useState("");
   const webcamRef = useRef();
   const canvasRef = useRef();

   const history = useHistory();

   const [previewImage, setPreviewImage] = useState("");
   const [isProcessing, setIsProcessing] = useState(false);
   const [isScannerLoading, setIsScannerLoading] = useState(false);

   const handleSelectWebcam = (value) => { setSelectedWebcam(value) };
   const [modalOpen, setModalOpen] = useState(false);
   const [scannerOn, setScannerOn] = useState(false);

   const [attendanceResultModalOpen, setAttendanceModalOpen] = useState(false);
   const [modalMsg, setModalMsg] = useState({ type: '', msg: '' });

   const [instructionModelOpen, setInstructionModelOpen] = useState(false);
   const { height, width } = useWindowDimensions();
   // const [camWidth, setCamWidth] = useState(width <= 420 ? 345 : 640);
   // const [camHeight, setCamHeight] = useState(width <= 420 ? 260 : 480);

   const [camWidth, setCamWidth] = useState(500);
   const [camHeight, setCamHeight] = useState(350);


   const showInstructionModal = async () => {
      setModalOpen(false);
      setAttendanceModalOpen(false);
      setInstructionModelOpen(true);
   };

   const closeInstructionModal = async () => {
      setModalOpen(false);
      setAttendanceModalOpen(false);
      setInstructionModelOpen(false);
      continueToAliv();
   };

   const continueToScan = async () => {
      setModalOpen(false);
      setAttendanceModalOpen(false);
      setInstructionModelOpen(false);
      setScannerOn(true);
      setIsScannerLoading(true);
   };
   const uploadMoreFaceImages = async () => {
      setModalOpen(false);
      history.push('/face-gallery');
   };

   const continueToAliv = async () => {
      setAttendanceModalOpen(false);
      window.open(`${CONFIG.ALIV_URL}/LifeGuard`, "_self");
   };


   useEffect(() => {
      setModalOpen((facePhotos.length > 0 && facePhotos.length < 5) ? true : false);
      // setScannerOn((facePhotos.length >= 5) ? true : false);
      if (facePhotos.length >= 5) {
         showInstructionModal()
      }
   }, []);

   useEffect(() => {
      navigator.mediaDevices.getUserMedia({ audio: false, video: true }).then(async (camDevice) => {
         if (camDevice?.id) {
            setIsWebcamEnabled(true);
            navigator.mediaDevices.enumerateDevices({ audio: false, video: true }).then((devices) => {
               let inputDevice = devices.filter((device) => device.kind === "videoinput");
               if (inputDevice?.length > 0 && inputDevice[0].deviceId) {
                  setInputDevices({ ...inputDevices, inputDevice });
                  setSelectedWebcam(inputDevice[0].deviceId);
               }
            });
         }
      });
   }, []);

   useEffect(() => {
      function capture() {
         if (
            typeof webcamRef.current !== "undefined" &&
            webcamRef.current !== null &&
            webcamRef.current?.video.readyState === 4
         ) {

            // Set canvas height and width
            canvasRef.current.width = webcamRef.current.video.offsetWidth;
            canvasRef.current.height = webcamRef.current.video.offsetHeight;

            // 4. TODO - Make Detections
            // e.g. const obj = await net.detect(video);

            let imgData = webcamRef.current.getScreenshot();
            setPreviewImage(imgData);
            // Draw mesh
            getFullFaceDescription(webcamRef.current.getScreenshot(), inputSize)
               .then((data) => {
                  setFullDesc(data);
                  setWaitText("");
               })
               .catch((err) => {
                  setWaitText("Preparing face matcher and device setup, please wait...");
               });
            const ctx = canvasRef.current.getContext("2d");

            drawRectAndLabelFace(fullDesc, faceMatcher, participants, ctx);

            if (!!fullDesc) {
               fullDesc.map(async (desc) => {
                  const bestMatch = faceMatcher.findBestMatch(desc.descriptor);
        
                  setIsScannerLoading(false);
                  // bestMatch._label != "unknown"
                  if (bestMatch?._label) {
                     clearInterval(interval);
                     const body = {
                        appuser_ID: user?.user_id,
                        event_time: new Date().toISOString(),
                        latitude: GeoLocationData?.coords?.latitude,
                        logitude: GeoLocationData?.coords?.longitude,
                        image: imgData,
                        scan_type: user?.scan_type,
                        facility_id: user?.facility_id
                     }

                     try {
                        if (!isProcessing) {
                           setIsProcessing(true);
                           setScannerOn(false);
                           const res = await _rest.markMyAttendance(body);
                           setIsProcessing(false);
                           if (res?.success === 'false') {
                              setModalMsg({ type: 'failed', msg: res?.msg })
                              Notification(res?.msg, res.status, 'danger');
                              setAttendanceModalOpen(true);
                           } else {
                              setModalMsg({ type: 'success', msg: res?.msg })
                              setAttendanceModalOpen(true);
                              Notification('Attendance Marked', res?.msg, 'success')
                              setTimeout(() => { continueToAliv(); }, 4000);
                           }
                        }
                     } catch (error) {
                        setIsProcessing(false);
                     }
                  }
               });
            }
         }
      }

      interval = setInterval(() => {
         capture();
      }, 700);
      return () => clearInterval(interval);
   });
   return (
      <>
         {!isFaceAPIModelsLoaded ?
            <>
               <FaceApiJsLoaded setIsFaceAPIModelsLoaded={setIsFaceAPIModelsLoaded} />
               <div className="face-api-loading loader">
                  <div>
                     <img src={ICONS.LoaderIcon} alt="" />
                     <h6>Please wait</h6>
                  </div>
               </div>
            </>
            : <>
               <main id="process-face-recognition">
                  <div className="scan-face-sub-header geo-location">
                     <h6>Face Scan Attendance Online <CheckCircleOutlineIcon style={{ marginTop: '-4px' }} fontSize="small" color="info" /></h6>
                     <h6>Location ON <PersonPinCircleIcon style={{ marginTop: '-4px' }} color='info' /> </h6>
                  </div>

                  {scannerOn && (
                     isWebcamEnabled ? (
                        <section id="webcam-scan-parent">
                           {/* <Form>
                              <div className="cam-options">
                                 <Form.Item label="Webcam">
                                    <Select
                                       defaultValue="Select Webcam"
                                       style={{ width: '100%', marginBottom: '8px' }}
                                       onChange={handleSelectWebcam}
                                       value={selectedWebcam}
                                    >
                                       {inputDevices?.inputDevice?.map((device) => (
                                          <Option key={device.deviceId} value={device.deviceId}>
                                             {device.label}
                                          </Option>
                                       ))}
                                    </Select>
                                 </Form.Item>

                              </div>
                           </Form> */}
                           <p style={{ fontSize: "18px" }}>{waitText}</p>

                           {!isProcessing ?
                              (
                                 <div className={isScannerLoading ? 'scanner-loading' : 'scanner-loaded'}
                                    style={{
                                       display: "flex",
                                       justifyContent: "center",
                                       alignItems: "center",
                                       marginTop: -30
                                    }}>

                                    <Webcam
                                       muted={true}
                                       ref={webcamRef}
                                       audio={false}
                                       screenshotFormat="image/jpeg"
                                       // width={camWidth}
                                       // height={camHeight}
                                       videoConstraints={{
                                          deviceId: '',
                                       }}
                                       mirrored
                                    />
                                    <canvas
                                       ref={canvasRef}
                                       style={{
                                          position: "absolute",
                                          textAlign: "center",
                                          zIndex: 8,
                                       }}
                                    />
                                    {isScannerLoading && (
                                       <div className="scanner-loader-box">
                                          <img src={ICONS.LoaderIcon} alt="" />
                                          <h4>Scanner is being initiated </h4>
                                          <h6>Change phone orientation landscape or <br />
                                             portrait for more accuracy</h6>
                                          <h5>Please keep your face still & be patient </h5>
                                       </div>
                                    )}
                                 </div>
                              ) :
                              (
                                 <div id="uploading-attendance-img">
                                    <img src={previewImage} alt="" className="face-img" />
                                    <div className="upload-icon">
                                       <img src={ICONS.LoaderIcon} alt="" />
                                       <h6>Uploading attendance...</h6>
                                    </div>
                                 </div>
                              )
                           }

                           {(width <= 420) ?
                              <div style={{ textAlign: 'center', marginTop: 60 }}>
                                 <h6 style={{ fontSize: 14, opacity: 0.7 }}>Attendance will be automatically <br />
                                    submitted once, right face is detected & <br />
                                    You will be redirected to ALiv site
                                 </h6>
                              </div> : null
                           }
                        </section>
                     ) :
                        (
                           <div className="geo-location loader">
                              <div>
                                 <h6>WebCam is disabled. <br />Please check your webcam permission from phone privacy/setting
                                    <br /> & browser to enable permission.</h6>
                              </div>
                           </div>
                        )
                  )}
               </main>
            </>
         }


         <Modal
            title="Please note !!"
            centered
            closable={false}
            open={modalOpen}
            width={'auto'}
            onOk={() => showInstructionModal()}
            onCancel={() => uploadMoreFaceImages()}
            cancelText="Upload more face images"
            okText="Continue to scan"
            wrapClassName="warning-pop-up"
         >
            <IconButton onClick={() => setModalOpen(false)} className="close-icon-btn">
               <CloseIcon />
            </IconButton>
            <h6>Upload minimum 5 face images for better face recognition</h6>
         </Modal>




         <Modal
            title="Instructions!"
            centered
            closable={false}
            open={instructionModelOpen}
            onOk={continueToScan}
            okText="Continue to scan"
            onCancel={closeInstructionModal}
            wrapClassName="warning-pop-up"
            width={600}
         >
            <IconButton onClick={() => setInstructionModelOpen(false)} className="close-icon-btn">
               <CloseIcon />
            </IconButton>

            <div style={{ display: "flex", justifyContent: "center", marginBottom: 16 }}>
               <img src={IMGS.instructions} />
            </div>
            {INSTRUCTIONS?.scan?.map((item, i) => (
               <Row key={i}>
                  <Col xs={1} className="m-auto p-0 text-end"><p className="instruction-p">{i + 1}. </p></Col>
                  <Col xs={11}><p className="instruction-p">{item}.</p></Col>
               </Row>
            ))}
         </Modal>



         <Modal
            title={modalMsg?.type === "failed" ? "Attendance Failed" : "Attendance Marked Success"}
            centered
            closable={false}
            open={attendanceResultModalOpen}
            onCancel={() => continueToScan()}
            cancelText="Rescan"
            onOk={() => continueToAliv()}
            okText={`Continue to Aliv`}
            wrapClassName={modalMsg?.type === "failed" ? "error-pop-up warning-pop-up" : "success-pop-up warning-pop-up"}
         >
            <IconButton onClick={() => continueToScan()} className="close-icon-btn">
               <CloseIcon />
            </IconButton>
            <h6>{modalMsg?.msg}</h6>
         </Modal>
      </>
   );
};
